import React, { useState, useEffect } from 'react';
import { LifeLine } from "react-loading-indicators";
import { v4 as uuidv4 } from 'uuid';
import Header from '../components/Header';
import Selector from '../components/Selector';
import MyText from '../components/MyText';
import Button from '../components/Button';
import Input from '../components/Input';
import Handler from '../services';
import Checkbox from '../components/Checkbox';
import { useLocation, useNavigate } from 'react-router-dom';
import tick from "../assets/tick.svg";
import cross from "../assets/crocetta.svg";
import toast from 'react-hot-toast';
import { useAuth } from '../context/AuthContext';


export default function Main() {
    const { userInfo } = useAuth();
    const { state } = useLocation();
    const pacchetto = false;
    const [pending, setPending] = useState(false);
    const selectedClient = state.client;
    const [selectedPet, setSelectedPet] = useState(state.pet ? state.pet : null);
    const [scanned, setScanned] = useState(false);
    // const [selected, setSelected] = useState("environment")
    const [desc, setDesc] = useState("");
    const [rif, setRif] = useState("");
    const [fattura, setFattura] = useState("");
    var [importo, setImporto] = useState(0.00);
    const [date, setDate] = useState(`${String(new Date().getFullYear())}-${String(new Date().getMonth() + 1).padStart(2, '0')}-${String(new Date().getDate()).padStart(2, '0')}`);
    const idClinica = userInfo.id;
    const nomeClinica = userInfo.nome_clinica;
    const handler = Handler();
    const navigate = useNavigate();
    const [redScreen, setRedScreen] = useState(false);
    const [greenScreen, setGreenScreen] = useState(false);
    const [prestaError, setPrestaError] = useState(false);
    const [isHovered, setIsHovered] = useState(false);
    const prestazioniOptions = ["Prestazione servizi veterinari", "Vendita prodotti", "Altre prestazioni"];
    const rifOptions = ["Scontrino", "Fattura", "Altro"];
    const parseAmount = (value) => Number.parseFloat(value);

    const checkRequest = async () => {
        if (importo <= 0) {
            toast.error("L'importo deve essere un numero positivo")
            return
        }
        if (importo > 3000) {
            toast.error("L'importo non può essere superiore a 3000")
            return
        }
        if (!selectedClient || !desc || !rif || !fattura || !date) {
            toast.error("I campi di inserimento sono errati.")
            return
        }
        if(selectedClient.amount == 0){
            toast.error("Il portafoglio del cliente è vuoto, non è possibile creare una movimentazione in PP")
            navigate("/")
            return
        }
        if (selectedClient.amount < importo) {
            toast((t) => (
                <div style={{ padding: 10 }}>
                    <p>
                        Il portafogli dell'utente non copre del tutto l'importo. Vuoi creare una movimentazione
                        di {selectedClient.amount} PP? Il residuo di {importo - selectedClient.amount} PP va
                        pagato in carta o contanti.
                    </p>
                    <div style={{ display: 'flex', justifyContent: "space-between", alignItems: "center" }}>
                        <Button
                            text={"Autorizza"}
                            callback={() => {
                                toast.dismiss(t.id);
                                sendRequest(true);
                            }}
                            textStyle={{ color: "white" }}
                        />
                        <Button
                            text={"Cancella"}
                            callback={() => {
                                toast.dismiss(t.id);
                                return;
                            }}
                            textStyle={{ color: "white" }}
                        />
                    </div>
                </div>
            ), {
                duration: Infinity,
            });
            return;
        }
        await sendRequest();
    }

    const sendRequest = async (correction = false) => {
        const inputImporto = parseAmount(importo);
        const requestedImporto = correction ? parseAmount(selectedClient.amount) : inputImporto;

        if (Number.isNaN(requestedImporto) || requestedImporto <= 0) {
            toast.error("L'importo finale della richiesta non e' valido. Aggiorna i dati del cliente e riprova.");
            return;
        }

        const updatedClient = await handler.getClientById(selectedClient.id);
        const updatedAmount = parseAmount(updatedClient?.associations?.wallet?.[0]?.pet_penny);

        if (Number.isNaN(updatedAmount)) {
            toast.error("Non sono riuscito a recuperare il saldo aggiornato del cliente. Riprova tra qualche secondo.");
            navigate("/")
            return;
        }

        if (updatedAmount <= 0) {
            toast.error("Il saldo aggiornato del cliente e' 0 PP. La richiesta non puo' essere inviata.");
            navigate("/")
            return;
        }

        if (correction && updatedAmount !== requestedImporto) {
            toast.error(`Il saldo del cliente e' cambiato, è necessario effettuare nuovamente la ricerca.`);
            navigate("/")
            return;
        }

        const newId = uuidv4();
        const params = { id: newId, idClinica, idCliente: selectedClient.id, idPet: selectedPet ? selectedPet.id : null, importo: requestedImporto }
        setPending(true);
        try {
            let apiKey = await handler.genera(pacchetto, params);
            let body = {
                id: newId,
                client: selectedClient,
                pet: selectedPet,
                importo: requestedImporto,
                idClinica,
                nomeClinica,
                apiKey,
                pacchetto,
                desc,
                rif,
                fattura,
                date
            }
            var pushRes = await handler.sendNotifications(body);
            if (!pushRes || pushRes.status !== 200 || !pushRes.data || pushRes.data.errors?.length > 0) {
                toast.error("Errore nell'invio della notifica. il cliente potrebbe aver disabilitato le notifiche push o potrebbe esserci un problema di connessione.");
                return;
            }
            let res = await handler.getStato(pacchetto, { id: newId })
            if (!res) {
                toast.error("Errore nel recupero dello stato della richiesta.");
                return;
            }
            if (res.stato === "Scaduta" || res.statusCode === 400) {
                toast.error('Richiesta scaduta');
            } else if (res.stato === "Confermato") {
                setGreenScreen(true);
            } else if (res.stato === "Rifiutato") {
                setRedScreen(true);
            } else if (res.stato === "Errore") {
                setRedScreen(true);
                setPrestaError(true);
            } else {
                toast.error("Stato della richiesta non riconosciuto.");
            }
        } catch (err) {
            toast.error("Si è verificato un errore sconosciuto.");
        } finally {
            setPending(false)
        }
    }

    if (pending) {
        return (
            <div style={{ height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                <LifeLine color="#282d68" size="large" text="Aspettando conferma dall'utente..." textColor="" />
            </div>
        )
    }

    if (redScreen) {
        return (
            <div style={{ ...styles.redContainer, backgroundColor: "#FF00007F" }}>
                <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                    <MyText style={{ ...styles.text, fontSize: "3rem" }}>
                        {prestaError ? "Errore nella creazione su Prestashop" : "Richiesta rifiutata!"}
                    </MyText>
                    <div style={styles.circContainer}>
                        <img src={cross} alt="cross" />
                    </div>
                </div>
                <div style={{ ...styles.prosegui, backgroundColor: isHovered ? "red" : "transparent" }}
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                    onClick={() => {
                        setRedScreen(false)
                        setIsHovered(false)
                    }}>
                    <MyText style={{ ...styles.text, fontFamily: 'Como-Bold' }}>Prosegui</MyText>
                </div>
            </div>
        )
    }

    if (greenScreen) {
        return (
            <div style={{ ...styles.redContainer, backgroundColor: "#00800080" }}>
                <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                    <MyText style={{ ...styles.text, fontSize: "3rem" }}>
                        Richiesta approvata correttamente!
                    </MyText>
                    <div style={styles.circContainer}>
                        <img src={tick} alt="tick" />
                    </div>
                </div>
                <div style={{ ...styles.prosegui, backgroundColor: isHovered ? "green" : "transparent" }}
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                    onClick={() => navigate("/")}>
                    <MyText style={{ ...styles.text, fontFamily: 'Como-Bold' }}>Prosegui</MyText>
                </div>
            </div>
        )
    }

    return (
        <div style={styles.container}>
            <div>
                <Header path="/RegistraAcquisto" />
                <div style={styles.selectSection}>
                    <Selector
                        client={selectedClient}
                        pet={selectedPet}
                        // clientChange={(val) => {
                        //     setScanned(false)
                        //     setSaldoUtente(val.amount)
                        // }}
                        petChange={(val) => {
                            setScanned(false)
                            setSelectedPet(val)
                        }}
                        scanned={scanned}
                    />
                </div>
                <div style={styles.inputSection}>
                    <div style={styles.textareaCol}>
                        <Checkbox
                            title="Tipo Prestazione"
                            obb={true}
                            options={prestazioniOptions}
                            onChange={(val) => setDesc(val)}
                        />
                    </div>
                    <div style={styles.rifCol}>
                        <Checkbox
                            title="Riferimento contabile"
                            obb={true}
                            options={rifOptions}
                            onChange={(val) => setRif(val)}
                        />
                    </div>
                    <div style={styles.inputCol}>
                        <Input
                            title="Numero documento"
                            obb={true}
                            initialValue={fattura}
                            callback={(val) => setFattura(val)}
                            width="100%"
                        />
                        <Input
                            title="Importo"
                            obb={true}
                            type="number"
                            initialValue={importo}
                            callback={(val) => setImporto(val)}
                            width="100%"
                        />
                    </div>
                    <div style={styles.buttonCol}>
                        <Input
                            title="Data"
                            obb={true}
                            type="date"
                            initialValue={date}
                            callback={(val) => setDate(val)}
                            width="100%"
                        />
                        <Button
                            text={"Genera acquisto"}
                            callback={checkRequest}
                            textStyle={{ color: "white" }}
                        />
                    </div>
                </div>
                {/* <Riepilogo list={productList} onUpdate={updateProduct} onRemove={removeProduct} editId={editId} /> */}
                {/* <div style={{
                    ...styles.btnWrap,
                    visibility: productList.length > 0 ? 'visible' : 'hidden'
                }}
                >
                    <Button
                        img={cart}
                        text={`Genera acquisto per € ${importo.toFixed(2)}`}
                        callback={sendRequest}
                        textStyle={{ color: "white" }} />
                </div> */}
            </div>
        </div>);
}
const styles = {
    container: {
        height: '100%',
        // width: '100%',
        // display: 'flex',
        // flex: 1,
        flexDirection: 'column',
        backgroundColor: '#f2f2f2',
        overflowY: 'auto'
        // justifyContent: 'center',
        // alignItems: 'center',
    },
    selectSection: {
        display: 'flex',
        alignItems: "center",
        marginTop: "2.5rem",
        marginBottom: "2rem",
        marginLeft: "5%",
        // marginRight: "5%"
    },
    inputSection: {
        display: "flex",
        marginBottom: "0rem",
        marginLeft: "5%",
        // marginRight: "5%"
    },
    textareaCol: {
        width: '25%',
        boxSizing: 'border-box',
    },
    rifCol: {
        width: '20%',
        boxSizing: 'border-box',
    },
    inputCol: {
        display: 'flex',
        flexDirection: 'column',
        width: '20%',
        boxSizing: 'border-box',
    },
    buttonCol: {
        display: 'flex',
        flexDirection: "column",
        paddingLeft: "10%",
        // width: "35%",
        // flex: 1,
        // justifyContent: "center",
        // alignItems: "center",
        boxSizing: 'border-box',
        paddingBottom: "20px"
    },
    btnWrap: {
        position: "absolute",
        bottom: "6vh",
        left: "25%",
        right: "25%",
        display: "flex",
        justifyContent: "center"
    },
    redContainer: {
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        // backgroundColor: "#FF00007F"
    },
    circContainer: {
        backgroundColor: "transparent",
        height: "3rem",
        width: "3rem",
        borderRadius: "50%",
        marginLeft: "2rem",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        border: "3px solid white",
        boxSizing: "border-box"
    },
    prosegui: {
        marginTop: "1.5rem",
        borderRadius: "2rem",
        padding: "0.5rem 1.5rem",
        border: "2px solid white",
        cursor: "pointer"
    },
    text: {
        color: "white",
        fontSize: "1.5rem"
    }
}
